import SiteHeader from "../Shared/SiteHeader";
import React from 'react'
import { NavLink } from 'react-router-dom'
import './Header-last.css'

export default function HeaderLast() {
  return (
    <div>
<SiteHeader>
            <li><NavLink end to="/">Home</NavLink></li>
            <li><NavLink end to="/about">About Us</NavLink></li>
            <li><NavLink end to="/career">Career</NavLink></li>
            <li><NavLink end to="/gallery">Gallery</NavLink></li>
            <li>
              <NavLink end to="/login" className="site-header__cta">
                Join Now
              </NavLink>
            </li>
          </SiteHeader>


    </div>
  )
}